<template>
  <div class="home-wrap">
    <div class="home">
      <div class="cover"><img src="@/assets/images/abbeyroad-cover.jpg" alt=""></div>
      <div class="info">
        <div class="title">Hey Jude</div>
        <div class="subtitle">The Beatles - Hey Jude</div>
        <div class="progress-wrap">
          <div class="current-time">2:54</div>
          <div class="progress-bar-wrap"></div>
          <div class="total-time">7:16</div>
        </div>
      </div>
      <div class="control">
        <div class="btn-wrap"><img src="@/assets/images/btn_cycle.svg" alt=""></div>
        <div class="btn-wrap"><img src="@/assets/images/btn_last-track.svg" alt=""></div>
        <div class="btn-wrap play"><img src="@/assets/images/play-btn.svg" alt=""></div>
        <div class="btn-wrap"><img src="@/assets/images/btn_next-track.svg" alt=""></div>
        <div class="btn-wrap"><img src="@/assets/images/btn_random.svg" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// // import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  }
}
</script>

<style lang="scss" scoped>
.home-wrap {
  .home {
    height: 93.4vh;
    padding-bottom: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    .cover {
      position: relative;
      width: 60vmin;
      height: 60vmin;
      max-width: calc(414px * .6);
      max-height: calc(414px * .6);
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 6px 8px 12px rgba(#000000, .16);
      img {
        width: 100%;
      }
      &:after {
        position: absolute;
        content: '';
        top: calc(50% - 6%);
        left: calc(50% - 6%);
        width: 12%;
        // height: 12vmin;
        padding-bottom: 12%;
        // max-width: calc(414px * .6);
        // max-height: calc(414px * .6);
        border-radius: 50%;
        background: #fff;
        box-shadow: inset 6px 6px 12px rgba(#000000, .5);
      }
    }
    .info {
      height: 20vmin;
      width: 90vmin;
      max-width: calc(414px * .9);
      line-height: 1.5;
      .title {
        font-size: 18px;
        font-weight: 600;
      }
      .subtitle {
        font-size: 14px;
        color: #9D9D9D;
      }
      .progress-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scale(.85);
        .current-time,
        .total-time {
          font-size: 10px;
          color: #9D9D9D;
        }
        .progress-bar-wrap {
          position: relative;
          margin: 20px 10px;
          flex-grow: 1;
          height: 9px;
          // background-color: red;
          border-radius: 4px;
          box-shadow: 0 3px 6px rgba(#000000, .16);
          &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 40%;
            border-radius: 4px;
            background-image: linear-gradient(to right, #FFE7E3, #F1644C, #EE553B);
          }
        }
      }
    }
    .control {
      height: 20vmin;
      width: 90vmin;
      max-width: calc(414px * .9);
      display: flex;
      justify-content: space-around;
      align-items: center;
      .play {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 1px 3px 8px rgba(#000, .2);
        img {
          margin-left: 13%;
        }
      }
    }
  }
}
</style>
